import { SuperTeamFundraisingPagesPage } from "@fwa/src/components/SuperTeamFundraisingPagesPage";
import Head from "next/head";

const Page = () => (
  <>
    <Head>
      <meta name="robots" content="noindex" />
    </Head>
    <SuperTeamFundraisingPagesPage />
  </>
);

export default Page;
